"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// import '@greatmindsorg/icominds-lib/dist/css/style.css';
var icominds_lib_1 = require("@greatmindsorg/icominds-lib");
var Icon = function (_a) {
    var name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, size = _a.size;
    return ((0, jsx_runtime_1.jsx)(icominds_lib_1.Icon, { name: name, className: className, size: size }));
};
exports.Icon = Icon;
exports.default = exports.Icon;
